import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private overlaySubject = new BehaviorSubject<boolean>(false);
  public overlay$ = this.overlaySubject.asObservable();

  public show(overlay: boolean): void {
    this.loadingSubject.next(true);
    this.overlaySubject.next(overlay);
  }

  public hide(): void {
    this.loadingSubject.next(false);
    this.overlaySubject.next(false);
  }
}
